<template>
  <v-dialog v-model="isOpened" max-width="880" :disabled="disabled" @after-leave="onCancel">
    <template v-if="slots.activator" #activator="{ props: activatorProps }">
      <div v-bind="activatorProps" @click="autoConfirm ? onConfirm() : null">
        <slot name="activator" />
      </div>
    </template>
    <div class="confirmation-dialog__content">
      <slot />

      <div class="confirmation-dialog__buttons">
        <e-btn variant="secondary" :loading="isCancelLoading" @click="onCancel"> {{ cancelText || 'Отмена' }}</e-btn>
        <e-btn :variant="confirmBtnVariant" :loading="isLoading || props.loading" @click="onConfirm">
          {{ confirmText }}
        </e-btn>
      </div>

      <e-btn
        variant="ghost"
        icon
        size="S"
        class="confirmation-dialog__closer"
        :loading="isCancelLoading"
        @click="onCancel"
      >
        <e-icon name="closeSvg" />
      </e-btn>
    </div>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { EBtn, EIcon } from '@/core/components/ui';

const props = withDefaults(
  defineProps<{
    action?: () => unknown | Promise<unknown>;
    cancelAction?: () => unknown | Promise<unknown>;
    confirmText: string;
    cancelText?: string;
    confirmBtnVariant?: 'primary' | 'accent';
    loading?: boolean;
    disabled?: boolean;
    autoConfirm?: boolean;
  }>(),
  {
    confirmBtnVariant: 'primary',
  },
);

const slots = defineSlots<{
  default: (props: unknown) => void;
  activator?: (props: unknown) => void;
}>();

const isOpened = defineModel<boolean>();

const closeDialog = () => {
  isOpened.value = false;
};

const isCancelLoading = ref(false);

const onCancel = async () => {
  if (props.cancelAction) {
    isCancelLoading.value = true;

    await props.cancelAction();

    isCancelLoading.value = false;
  }

  closeDialog();
};

const isLoading = ref(false);

const onConfirm = async () => {
  isLoading.value = true;

  if (props.action) {
    await props.action();
  }

  isLoading.value = false;

  closeDialog();
};
</script>

<style scoped lang="scss">
.confirmation-dialog {
  &__content {
    position: relative;

    padding: 40px;

    background-color: $main-bg-color;
    border-radius: $border-radius-xl;
  }

  &__buttons {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;

    gap: 24px;

    margin-top: 40px;

    @include sm-and-down {
      gap: 8px;
    }
  }

  &__closer {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
</style>
